import { render, staticRenderFns } from "./SystemUsersTable.vue?vue&type=template&id=2fc5a5c6&"
import script from "./SystemUsersTable.vue?vue&type=script&lang=js&"
export * from "./SystemUsersTable.vue?vue&type=script&lang=js&"
import style0 from "./SystemUsersTable.vue?vue&type=style&index=0&id=2fc5a5c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports